<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas
      :notificacaoSocket="alertaSocket"
      :texto="alerta.texto"
      :tipo="alerta.tipo"
    ></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Setores'"
      :newRowmodalButtonText="'Novo Setor'"
      :tableHeader="headers"
      :tableRows="listSetor"
      :isEdit="true"
      :isFinish="false"
      :isDel="true"
      :isPrint="false"
      v-on:datatable-newrow="onDataTableInsertRow"
      v-on:datatable-updaterow="onDataTableUpdateRow"
      v-on:datatable-deleterow="onDataTableDeleteRow"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :modalSize="modalCustomSize.modalSize"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="onFormModalAction"
    >
      <v-form v-model="isFormValid">
        <v-row>
          <v-col cols="12">
            <AlertasModal
              :tipo="alertaModal.tipo"
              :texto="alertaModal.texto"
            ></AlertasModal>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="modalCustomSize.actualEdit.nomeSetor"
              name="descricaoSolicitarItem"
              label="Nome do setor"
              autocomplete="off"
              counter="255"
              :rules="[rules.required, rules.limitCharacters]"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="modalCustomSize.actualEdit.descricaoSetor"
              name="descricaoSolicitarItem"
              label="Descrição do setor"
              autocomplete="off"
              counter="255"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </ModalCustomSize>
    
    <DeleteItemModal
      :textModalDelete="modalDelete.textModalDelete"
      :showModalDelete="modalDelete.closeModal"
      :buttomTextModalDelete="'Excluir'"
      v-on:on-response-modal-delete="onResponseModalDelete"
      v-on:close-modal="modalDelete.closeModal = false"
    ></DeleteItemModal>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DataTable from "../components/DataTable2";
import store from "@/store/index";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import DeleteItemModal from "../components/DeleteItemModal";
import SkeletonTable from "../components/SkeletonTable";

export default {
  components: {
    DataTable,
    Loading,
    ModalCustomSize,
    DeleteItemModal,
    SkeletonTable,
    Alertas,
    AlertasModal
  },

  data: () => ({
    rules: {
      required: (value) => !!value || "Requer o campo!",
      limitCharacters: v => v && v.length <= 255 || 'Limite de 255 caracteres.'
    },

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    modalDelete: {
      numeroSetor: null,
      closeModal: null,
      textModalDelete: "Você realmente deseja deletar esse setor?",
      descricaoTela: "Setor",
    },

    showSkeletonTable: true,
    loading: false,
    isFormValid: false,

    // Cabeçalho da DataTable
    headers: [
      {
        text: "ID Setor",
        value: "numeroSetor",
      },
      {
        text: "Nome do Setor",
        value: "nomeSetor",
      },
      {
        text: "Descrição do Setor",
        value: "descricaoSetor",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    modalCustomSize: {
      modalSize: "1080",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroEndereco: store.state.numeroEndereco,
        numeroSetor: null,
        nomeSetor: null,
        descricaoSetor: null,
        descricaoTela: "Setor",
      },
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    //Array populado pela função initialize
    listSetor: [],
  }),

  created() {
    this.initialize();
  },

  watch: {
    isFormValid() {
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
    },
  },

  methods: {
    async initialize() {
      try {
        await this.getSetor();
      } catch (error) {
        console.log(error);
      }
    },

    /****************************************************************
     *                 FUNÇÕES DE EVENTO
     *****************************************************************/

    onDataTableInsertRow() {
      this.loading = true
      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = false;
      this.modalCustomSize.buttonText = "Concluir";
      this.modalCustomSize.formTitle = "Novo Setor";

      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
      this.modalCustomSize.actualEdit.nomeSetor = null;
      this.modalCustomSize.actualEdit.descricaoSetor = null;
      this.loading = false
    },

    onDataTableUpdateRow(item) {
      this.loading = true
      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = true;
      this.modalCustomSize.buttonText = "Concluir";
      this.modalCustomSize.formTitle = "Atualizar Setor";
      
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
      this.modalCustomSize.actualEdit.numeroSetor = item.numeroSetor;
      this.modalCustomSize.actualEdit.nomeSetor = item.nomeSetor;
      this.modalCustomSize.actualEdit.descricaoSetor = item.descricaoSetor;
      this.loading = false
    },

    onDataTableDeleteRow(item) {
      this.modalDelete.numeroSetor = item.numeroSetor;
      this.modalDelete.closeModal = true;
    },

    async onResponseModalDelete() {
      try {
        await this.delete();
      } catch (error) {
        console.log(error);
      } finally {
        this.modalDelete.closeModal = false;
      }
    },

    async onFormModalAction() {
      try {
        this.modalCustomSize.isButtonsDisabled = true;
        if (this.modalCustomSize.isEdit) {
          await this.update(this.modalCustomSize.actualEdit);
        } else {
          await this.insert(this.modalCustomSize.actualEdit);
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.modalCustomSize.isButtonsDisabled = false;
      }
    },

    /****************************************************************
     *                 FUNÇÕES DE REQUISIÇÕES
     **************************************************************** */

    async getSetor() {
      try {
        const sendToken = {
          numeroEndereco: store.state.numeroEndereco,
        };

        let response = await axios.put("setorUnidade", sendToken, this.config);

        this.showSkeletonTable = false;
        this.listSetor = response.data;
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async insert(reciveItem) {
      try {
        this.modalCustomSize.isLoadingRequestDisable = true;

        await axios.post("setorUnidade", reciveItem, this.config);
      
        this.modalCustomSize.isOpen = false;
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
        this.initialize();
      }
    },

    async update(reciveItem) {
      try {
        this.modalCustomSize.isLoadingRequestDisable = true;

        await axios.put("setorUnidadeUpdate", reciveItem, this.config);
      
        this.modalCustomSize.isOpen = false;
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
        this.initialize();
      }
    },

    async delete() {
      try {
        this.modalCustomSize.isLoadingRequestDisable = true;

        await axios.delete("setorUnidade", {
          data: this.modalDelete,
          headers: this.config.headers,
        });

       
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
        this.initialize();
      }
    },

    fecharNotificacao() {
      this.newNotify.isNewNotify = false;
    },
  },
};
</script>